// NPM
import React, { useEffect } from "react";
import _ from "lodash";

// State
import { useSelector } from "react-redux";

function RedditButton() {
  // State
  const campaignConfig = useSelector((state) => state.campaignConfig.value);
  const region = useSelector((state) => state.region.value);
  const sub = _.get(campaignConfig, `social.redditSub`);

  if (_.isBlank(campaignConfig) || _.isBlank(region) || !sub) {
    return null;
  }

  const share = () => {
    const absoluteShareUrl = _.get(campaignConfig, `social.absoluteShareUrl`);
    const title = encodeURIComponent(
      `${_.get(campaignConfig, "social.redditText")}`,
    );

    window.open(
      `https://reddit.com/r/${sub}/submit?title=${title}&url=${absoluteShareUrl}`,
      "_blank",
    );
  };

  return (
    <button className="ShareButton RedditButton" onClick={share}>
      <img src={require("images/reddit.png")} alt={"Share on Reddit"} />
    </button>
  );
}

export default RedditButton;
